import { Redirect } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { PrescriptionOnlyVisitPanel } from './PrescriptionOnlyVisitPanel';
import { VisitPanelLoader } from './VisitPanel.loader';
import { documentationScopeVisitor } from './VisitPanel.utils';

export const PrescriptionVisitPanel = (): JSX.Element => {
   const { visitId } = visitPaths.usePrescriptionVisitParams();

   return (
      <VisitPanelLoader visitId={visitId}>
         {({ visit }) =>
            documentationScopeVisitor(visit.documentationScope)({
               prescriptionOnly: () => <PrescriptionOnlyVisitPanel visit={visit} />,
               full: () => <Redirect path={visitPaths.getVisitInterviewPath({ params: { visitId: visit.id } })} />,
            })
         }
      </VisitPanelLoader>
   );
};
